import React from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { venueStatusOptions } from "../../utils/constants/venues-constants";
import { VenueStatus } from "../../models/venues";

interface VenueFiltersProps {
  venueName: string;
  setVenueName: React.Dispatch<React.SetStateAction<string>>;
  status?: VenueStatus;
  setStatus: React.Dispatch<React.SetStateAction<VenueStatus | undefined>>;
}

export const VenueFilters = ({
  venueName,
  setVenueName,
  status,
  setStatus,
}: VenueFiltersProps) => {
  return (
    <div className="flex flex-wrap align-items-end gap-3 mb-4">
      <div className="flex flex-column gap-2">
        <label htmlFor="venueName" className="text-600 text-sm">
          Nombre
        </label>
        <IconField iconPosition="left" className="w-full">
          <InputIcon className="pi pi-search" />
          <InputText
            id="venueName"
            name="venueName"
            onChange={(e) => setVenueName(e.currentTarget.value)}
            value={venueName}
            className="w-full"
            style={{ minWidth: "14rem" }}
          />
        </IconField>
      </div>
      <div className="flex flex-column gap-2">
        <label htmlFor="venueStatus" className="text-600 text-sm">
          Estado
        </label>
        <Dropdown
          id="venueStatus"
          name="venueStatus"
          onChange={(e: DropdownChangeEvent) => setStatus(e.value)}
          value={status}
          optionLabel="name"
          optionValue="value"
          options={venueStatusOptions}
          placeholder="Seleccionar estado"
          showClear
          style={{ minWidth: "14rem" }}
        />
      </div>
    </div>
  );
};
